import { render, staticRenderFns } from "./BusinessInformationCategory.vue?vue&type=template&id=0e10c99f"
import script from "./BusinessInformationCategory.vue?vue&type=script&lang=js"
export * from "./BusinessInformationCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports